import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, PopoverController } from 'ionic-angular';
import { GN } from '../../../gn';
import { ShowonearticlePage } from '../showonearticle/showonearticle';
import { PopupPage } from '../../popup/popup';
import { base64StringToBlob } from 'blob-util';

/**
 * Generated class for the ShowmorearticlesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-showmorearticles',
  templateUrl: 'showmorearticles.html',
})
export class ShowmorearticlesPage {
  loadingData: boolean = false
  classTxt = ''
  classId = ''
  classobjs = []
  articleid = -1
  article: string = ''
  artObj = []
  artClassObjs = []
  _offset = 0;
  _endArt = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public viewCtrl: ViewController, public popoverCtrl: PopoverController) {
    this.classTxt = navParams.get('txt')
    this.classId = navParams.get('id')
    // this.classobjs = navParams.get('classobjs')
    this.article = '- Изберете -'
  }


  ionViewDidLoad() {
    this.artClassObjs = []
    this._offset = 0;
    var _that = this
    this.viewCtrl.showBackButton(false);
    console.log('ionViewDidLoad ShowmorearticlesPage');
    this.getArticlesByClass();
  }

  getArticlesByClass() {
    var _that = this
    this.loadingData = true
    this.gn._Post('/api/getmebelviarticlesbyclass', { offset: _that.gn.crypt(_that._offset), class: _that.gn.crypt(_that.classId), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
      if (_data.length < 10) {
        _that._endArt = true;
      }
      for (var a = 0; a < _data.length; a++) {
        _data[a].acDescr = (_data[a].acDescr).replace(/\n/g, "^~^");
        _data[a].acDescr = (_data[a].acDescr).replace(/\r/g, "");
        var k = _data[a].acDescr
        var karr = k.split('^~^')

        _that.artClassObjs.push({ ident: _data[a].acIdent, name: _data[a].acName, descr: karr, price: _data[a].price, tip: _data[a].tip, img: 'mebelvi/mebelViSlika1.jpg' })
        //debugger
        if (a == _data.length - 1) {
          setTimeout(() => {
            for (var b = 0; b < _data.length; b++) {
              //debugger
              if (_data[b].blob != null && _data[b].blob != undefined) {
                var arrayBufferView = new Uint8Array(_data[b].blob.data);
                var blob1 = new Blob([arrayBufferView], { type: "image/jpeg" });
                var contentType = 'image/png';
                var blobUrl = URL.createObjectURL(blob1);
                var imgObj = <HTMLImageElement>document.getElementById('image' + _data[b].acIdent)
                imgObj.src = blobUrl
              }
              if (b == _data.length - 1) {
                _that.loadingData = false
              }
            }
          }, 100);
        }
      }
    })
  }

  ShowDetails(_obj) {
    this.navCtrl.push(ShowonearticlePage, { txt: _obj.name, id: _obj.ident, obj: _obj, classTxt: this.classTxt })
  }

  openArticlePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'АrticlesByClass', selected: [], class: _that.classId, callback: function (_text, _ids) {
        _that.articleid = _ids
        _that.article = _text
        _that.gn._Post('/api/getmebelviarticle', { ident: _that.gn.crypt(_that.articleid), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
          _that.artObj = []
          _data[0].acDescr = (_data[0].acDescr).replace(/\n/g, "^~^");
          _data[0].acDescr = (_data[0].acDescr).replace(/\r/g, "");
          var k = _data[0].acDescr
          var karr = k.split('^~^')
          _that.artObj.push({ ident: _data[0].acIdent, name: _data[0].acName, descr: karr, price: _data[0].price, tip: _data[0].tip, img: 'mebelvi/mebelViSlika1.jpg' })
          _that.navCtrl.push(ShowonearticlePage, { txt: _that.article, id: _that.articleid, obj: _that.artObj[0] })
        })
      }
    }, { cssClass: 'popover-content-articles1' });
    popover.present({ ev: _ev });
  }

  moreArticles() {
    this._offset = this._offset + 10;
    this.getArticlesByClass();
  }

}



// WEBPACK FOOTER //
// ./src/pages/mebelvisalon/showmorearticles/showmorearticles.ts